import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Schedules = lazy(() => import('../../container/schedules'));

const SchedulesRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/schedules`} component={Schedules}/>
        </Switch>
    );
};

export default SchedulesRoutes;
